/* global */
'use strict'

var Joi = require('joi-browser')
import merge from 'merge'
import _ from 'lodash'
import $ from 'jquery'
import Vue from 'vue'
import ErrorText from './joi-form-error-text'
import ErrorCallout from './joi-form-error-callout'

export default Vue.extend({
  name: 'joi-form',
  template: '<form method="post" v-on:submit.prevent="submit"><slot></slot></form>',
  props: ['data', 'schema', 'error'],
  components: {
    'errot-text': ErrorText
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
    error: function (err) {
      this.clearAllErrors()
      if (err) {
        this.displayErrors(err)
      }
    }
  },
  methods: {
    submit (event) {
      this.validate()
    },
    validate () {
      var options = {allowUnknown: true, abortEarly: false}
      this.clearAllErrors()
      Joi.validate(this.data, this.schema, options, (err, validatedData) => {
        if (err) {
          this.onValidationFailed(err)
        } else {
          this.onValidationSuccess(validatedData)
        }
      })
    },
    onValidationFailed (err) {
      this.$emit('validationfailed', err)
      this.displayErrors(err)
    },
    onValidationSuccess (validatedData) {
      this.$emit('validationsuccess', validatedData)
      this.composeFormData(validatedData)
    },
    composeFormData (validatedData) {
      // var formData = new FormData()
      var formData = {}
      var self = this

      $('input[name],select[name]', this.$el).each(function () {
        var name = $(this).attr('name')
        var value = self.getFormDataForInput(this, validatedData[name])
        if (value && value.filename) {
          // formData.append(name, value.value, value.filename)
        } else {
          if (self.isValidValue(value)) {
            // formData.append(name, value)
            formData[name] = value
          }
        }
      })

      this.extendFormDataWithPropData(formData)

      this.$emit('formdataready', formData)
    },
    extendFormDataWithPropData (formData) {
      _.forOwn(merge(true, this.data), (value, key) => {
        if (!formData.hasOwnProperty(key) && this.isValidValue(value)) {
          formData[key] = value
          // if (_.isArray(value)) {
          //   _.forEach(value, (item) => {
          //     formData.append(key + '[]', item)
          //   })
          // } else {
          //   formData.append(key, value)
          // }
        }
      })
    },
    isValidValue (value) {
      return !_.isUndefined(value) && !_.isNull(value)
    },
    getFormDataForInput (inputEl, validatedValue) {
      var el = $(inputEl)
      if (el.attr('type') === 'file') {
        if (!inputEl.files.length) {
          return null
        }
        return {
          value: inputEl.files[0],
          filename: validatedValue || el.val()
        }
      }

      return validatedValue === undefined ? el.val() : validatedValue
    },
    displayErrors (error) {
      if (error.isJoi) {
        return this.displayJoiValidationErrors(error)
      }

      return this.displayCommonError(error)
    },
    displayJoiValidationErrors (validationError) {
      this.clearInputErrors()
      for (let inputError of validationError.details) {
        this.displayInputError(inputError)
      }
    },
    displayInputError (inputError) {
      var component = this.findErrorComponentByPath(inputError.path)

      if (!component) {
        component = this.createErrorComponentForInputError(inputError)
      }

      if (component) {
        component.message = inputError.message
        component.show()
      } else {
        console.log('Can not display error message', inputError)
      }
    },
    displayCommonError (error) {
      this.clearCommonError()
      this.createErrorComponentForFormError()
      this.queryErrorComponentsFor('form').forEach((component) => {
        component.message = error.message
        component.show()
      })
    },
    clearAllErrors () {
      this.clearInputErrors()
      this.clearCommonError()
    },
    clearInputErrors () {
      this.queryErrorComponentsFor('input').forEach((component) => {
        component.message = null
        component.hide()
      })
    },
    clearCommonError () {
      this.queryErrorComponentsFor('form').forEach((component) => {
        component.message = null
        component.hide()
      })
    },
    createErrorComponentForFormError (inputError) {
      var targetEl = $('[data-form-error-callout]', this.$el)
      var errEl = null

      if (targetEl.length) {
        errEl = new ErrorCallout()
        errEl.for = 'form'
        errEl.$mount(targetEl.get()[0])
        this.$children.push(errEl)
      }
      return errEl
    },
    createErrorComponentForInputError (inputError) {
      var inputEl = this.findInputElementByPath(inputError.path)
      var errEl = null
      var errElTarget = null

      if (inputEl.length) {
        errElTarget = $('<error-text></error-text>')
        inputEl.after(errElTarget)

        errEl = new ErrorText()
        errEl.for = 'input'
        errEl.$mount(errElTarget.get()[0])
        this.$children.push(errEl)
      }
      return errEl
    },
    queryErrorComponentsFor (filterFor) {
      return this.$children.filter((component) => {
        return component.$options.isFormError && (!filterFor || component.for === filterFor)
      })
    },
    findErrorComponentByPath (path) {
      return this.$children.find((component) => {
        return component.$options.isFormError && component.path === path
      })
    },
    findInputElementByPath (path) {
      var selectors = [
        '[error-path="' + path + '"]',
        'input[name="' + path + '"]',
        'select[name="' + path + '"]'
      ]
      var result

      for (var i = 0; i < selectors.length; i++) {
        result = $(selectors[i], this.$el).first()
        if (result.length) {
          return result
        }
      }

      return []
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/inputs/joi-form.js